<template lang="pug">
  #loading(:class="{ loading: true, fadeout: !isLoading }")
    .loading-image.text-center
      img.loading-logo.mb-2(src="/assets/mvdf.svg")
      br
      img.loading-title(src="/assets/header-title.png")
      .loader
</template>
<script>
export default {
  name:"loading",
  props: ["isLoading"],
}
</script>
<style lang="scss">
.loading {
  background: url("/assets/Bienvenida_MemorialDisperso.png");
  background-size: contain;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  display: block;
  overflow: hidden;
  position: fixed;
  .loading-image {
    padding-top: 30vh;
    z-index: 150;
  }
  .loading-logo {
    max-height: 14vh;
    height: 12vh;
    max-width: 100%;
    object-fit: contain;

  }
  .loading-title {
    max-height: 10vh;
    height: auto;
    max-width: 100%;
  }
  .loader {
    display: flex;
    border: 2px solid #f3f3f3;
    border-top: 2px solid #999943; 
    border-radius: 50%;
    width: 3rem;
    height: 3rem;
    animation: spin 2s linear infinite;
    margin: 25vh auto 0 auto;
  }
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  
}
.fadeout {
    animation: fadeout 2s forwards;
  }

  @keyframes fadeout {
    to {
      opacity: 0;
      visibility: hidden;
   }
  }

</style>